import React, { useEffect, useMemo } from 'react';

import _ from 'lodash';
import cx from 'classnames';

import styles from './group.module.scss';

const GroupWidgetComponent = ({ className, style, widgetProps, breakpoint, children }) => {

  const id = _.get(widgetProps, 'uid');
  const type = _.get(widgetProps, 'type');

  var widgetStyle = {
    ...style
  }

  return (
    <div id={id}
      className={cx(className, styles.groupWidget, 'cs_group_widget', {
        [styles.mobile]: breakpoint === 'mobile'
      })}
      data-widget-id={id}
      data-widget-type={type}
      data-container={false}
      data-selectable={true}
      style={widgetStyle}
    >
      {children}
    </div>
  )
}


const groupWidgetEquals = function (prevProps, nextProps) {
  const paths = ['className', 'style', 'widgetProps', 'breakpoint', 'children'];
  const next = _.pick(nextProps, paths);
  const previous = _.pick(prevProps, paths);

  const equals = _.isEqual(next, previous);
  return equals;
}

export const GroupWidget = React.memo(GroupWidgetComponent, groupWidgetEquals);
